import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../AuthContext"; // Ajusta la ruta según tu estructura

const CrearUsuario = () => {
  const { user } = useContext(AuthContext);
  const [form, setForm] = useState({
    username: "",
    nombre: "",
    role: "Lector"
  });

  const [usuarios, setUsuarios] = useState([]);
  const [mensaje, setMensaje] = useState("");

  // ✅ Cargar usuarios existentes al montar el componente
  useEffect(() => {
    if (user?.role === "Administrador") {
      fetchUsuarios();
    }
  }, [user]);

  const fetchUsuarios = async () => {
    try {
      const response = await axios.get("http://192.168.1.81:5000/backend/api/usuarios", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setUsuarios(response.data);
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("http://192.168.1.81:5000/backend/api/usuarios", form, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    

      setMensaje(`Usuario creado. Contraseña por defecto: u${form.username.slice(0, 6)}`);
      setForm({ username: "", nombre: "", role: "Secretario" });

      // ✅ Actualizar lista
      fetchUsuarios();
    } catch (err) {
      console.error("Error al crear usuario:", err);
      setMensaje("Error al crear usuario. Verifica que no exista el username.");
    }
  };

  if (!user || user.role !== "Administrador") return null;

  return (
    <div style={{ padding: "1rem", maxWidth: "700px", margin: "0 auto" }}>
      <h3>Crear nuevo usuario</h3>
      <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
        <input
          type="text"
          name="username"
          placeholder="Rut de Usuario (sin puntos ni guión)"
          value={form.username}
          onChange={handleChange}
          required
        />
        <br />
        <input
          type="text"
          name="nombre"
          placeholder="Nombre completo"
          value={form.nombre}
          onChange={handleChange}
          required
        />
        <br />
        <select name="role" value={form.role} onChange={handleChange}>
          <option value="Administrador">Administrador</option>
          <option value="Secretario">Secretario</option>
          <option value="Digitador">Digitador</option>
          <option value="Lector">Lector</option>
          <option value="Ejecutivo">Ejecutivo</option>
          <option value="Contador">Contador</option>
        </select>
        <br />
        <button type="submit">Crear usuario</button>
      </form>
      {mensaje && <p>{mensaje}</p>}

      <h4>Usuarios existentes</h4>
      <table border="1" cellPadding="8" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Username</th>
            <th>Nombre</th>
            <th>Rol</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.length > 0 ? (
            usuarios.map((u) => (
              <tr key={u.id}>
                <td>{u.username}</td>
                <td>{u.nombre}</td>
                <td>{u.role}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center" }}>
                No hay usuarios registrados
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CrearUsuario;
